import Vue from 'vue';

export default new Vue({
  methods: {
    edit(campaignDate) {
      this.$emit('campaign-dates-on-edit', campaignDate);
    },
  },
});
